import React, { useState, FormEvent } from 'react';
import {
    Card,
    Title,
    TextInput,
    Button,
    Select,
    Notification,
    Group
} from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import axios from 'axios';
import {MembershipRole} from "../../models/Membership";
import {BackendUrl} from "../../util/config";


// Props: only one organization ID
interface CreateInvitationProps {
    organizationId: string;
}

export const CreateInvitation: React.FC<CreateInvitationProps> = ({ organizationId }) => {
    const [email, setEmail] = useState('');
    const [role, setRole] = useState<MembershipRole>(MembershipRole.MEMBER);

    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setSuccessMessage(null);
        setErrorMessage(null);

        try {
            // Build the invitation payload
            const payload = {
                email,
                role,
                organizationId,  // we pass in the single org ID from props
            };

            // If you need JWT, retrieve from localStorage or context
            const token = localStorage.getItem('jwt');

            const response = await axios.post(`${BackendUrl}/invitations`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token ? `Bearer ${token}` : '',
                },
            });
            console.log(response)

            // On success, the server returns the created invitation
            setSuccessMessage(`Invitation sent to ${email}. Token: ${response.data.token}`);
            // Optional: reset fields
            setEmail('');
            setRole(MembershipRole.MEMBER);
        } catch (error: any) {
            console.log(error)
            const msg = error?.response?.data || 'Error sending invitation';
            setErrorMessage(msg);
        }
    };

    return (
        <Card withBorder p="md" radius="md">
            <Title order={3} mb="sm">
                Einladung senden
            </Title>

            {/* Display success or error */}
            {successMessage && (
                <Notification
                    icon={<IconCheck size={18} />}
                    color="teal"
                    mb="md"
                    onClose={() => setSuccessMessage(null)}
                >
                    {successMessage}
                </Notification>
            )}
            {errorMessage && (
                <Notification
                    icon={<IconX size={18} />}
                    color="red"
                    mb="md"
                    onClose={() => setErrorMessage(null)}
                >
                    {errorMessage}
                </Notification>
            )}

            <form onSubmit={handleSubmit}>
                <TextInput
                    label="E-Mail"
                    placeholder="mitarbeiter@example.com"
                    required
                    withAsterisk
                    value={email}
                    onChange={(e) => setEmail(e.currentTarget.value)}
                    mb="sm"
                />

                <Select
                    label="Rolle"
                    placeholder="Wähle eine Rolle aus"
                    data={[
                        { value: 'ADMIN', label: 'Administrator' },
                        { value: 'MEMBER', label: 'Mitglied' },
                    ]}
                    // we do value={role as string} so the Select sees a string
                    value={role as string}
                    onChange={(val) => setRole(val as MembershipRole)}
                    mb="sm"
                    withAsterisk
                />

                <Group>
                    <Button type="submit">Sende Einladung</Button>
                </Group>
            </form>
        </Card>
    );
};
